/**
 * searchSheetStore — H5 `#searchWindow` sheet open/close state.
 *
 * audit-2026-05-18 (deep, P1 paradigm): H5 search lives as a sheet overlay
 * on top of the current view (home / board / etc), not as a separate route.
 * `main.js:8022 openSearchWindow()` toggles `els.searchWindow.classList.add("is-open")`
 * while the home view stays mounted underneath; closing returns the user to
 * the same scroll position. React previously used a `/search` route which
 * unmounted the page behind it, leaving a gray backdrop instead of the
 * home wall.
 *
 * This store mirrors `useComposeStore` / `useDriftBottleSheet` so App.tsx
 * can mount a lazy `<SearchSheetHost />` next to ComposeSheetHost without
 * tripping `lint_no_global_chrome` (the lint allowlist already permits
 * lazy sheet portals).
 *
 * `/search` route still exists for deep-link compatibility — it renders a
 * thin wrapper that opens the store on mount.
 */

import { create } from "zustand";

type SearchSheetState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useSearchSheetStore = create<SearchSheetState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
